<mf-page title="Nueva notificación">
  <mf-notification
    (close)="close()"
    (save)="submit($event)" />
</mf-page>
